import { render, staticRenderFns } from "./SysRelatoriosCompra.vue?vue&type=template&id=43c0fcc4&scoped=true"
import script from "./SysRelatoriosCompra.vue?vue&type=script&lang=js"
export * from "./SysRelatoriosCompra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c0fcc4",
  null
  
)

export default component.exports